// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@awc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { orderStatusInformationStyles } from "@awc/Overrides/Widgets/OrderStatus/OrderStatusInformation";
import { styledBoxStyle } from "@awc/XDL/Components/Common/Box";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

orderStatusInformationStyles.wrapper = {
    ...xOrderInformationStyles.headingAndTextStyles?.wrapper,
};

orderStatusInformationStyles.titleText = {
    ...xOrderInformationStyles.headingAndTextStyles?.heading,
};

orderStatusInformationStyles.addressText = {
    ...xOrderInformationStyles.address?.heading,
};

orderStatusInformationStyles.orderDateText =
    orderStatusInformationStyles.orderNumberText =
    orderStatusInformationStyles.statusText =
    orderStatusInformationStyles.termsText =
    orderStatusInformationStyles.poNumberText =
    orderStatusInformationStyles.shippingMethodText =
        {
            ...xOrderInformationStyles.headingAndTextStyles?.text,
        };

orderStatusInformationStyles.informationWrapper = {
    css: css`
        display: flex;
        gap: 16px;
        & > div {
            flex-basis: 50%;
        }
        ${styledBoxStyle}
        ${xScreen("lte", "md")} {
            & > div {
                flex-basis: 100%;
            }
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
        @media print {
            flex-direction: row;
        }
    `,
};

orderStatusInformationStyles.shippingAddressWrapper = {
    css: css`
        padding-bottom: 0;
        margin-top: 24px;
    `,
};
orderStatusInformationStyles.billingAddressWrapper = {
    css: css`
        padding-bottom: 0;
    `,
};

orderStatusInformationStyles.shippingMethodeWrapper = {
    ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles?.wrapper, {
        css: css`
            flex-direction: column;
            margin-top: 24px;
            margin-bottom: 0;
        `,
    }),
};

orderStatusInformationStyles.shippinMethodTitle = {
    ...mergeWithCss(xOrderInformationStyles.label, {
        css: css`
            margin-bottom: 12px;
        `,
    }),
};

orderStatusInformationStyles.shippingMethodText = {
    ...xOrderInformationStyles.note?.text,
    as: "p",
};
